import { Box } from "@mui/material";
import {
  cellClassName,
  DataTableV2,
  defaultColDef,
  useAgGridOptions,
} from "@platform/design-system";

import { useCarrierBonus } from "../../../hooks/useBbe";
import { CARRIER_BONUS_SUMMARY_TABLE_COLUMN_HEADERS } from "../constants";

const PAGE_SIZE = 10;

type CarrierBonusSummaryTableProps = {
  brokerId: string;
};

export const CarrierBonusSummaryTable: React.FC<
  CarrierBonusSummaryTableProps
> = ({ brokerId }) => {
  const rows = useCarrierBonus(brokerId);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { resetPage, ...dataTableOptions } = useAgGridOptions({});
  const columns = CARRIER_BONUS_SUMMARY_TABLE_COLUMN_HEADERS.map((col) => ({
    ...col,
    ...defaultColDef,
    flex: 1,
    wrapText: false,
  }));

  return (
    <Box
      sx={{
        // there is a default min-height on the table container which (sometimes) creates
        // an empty gap IF there are fewer rows than the page size when using client side rendering
        // this is set to remove the min height so that we can remove the empty gap
        "& .ag-center-cols-viewport": {
          minHeight: "unset !important",
        },
        [`& .${cellClassName} .ag-cell-wrapper`]: {
          display: "grid",
          alignItems: "center",
          minHeight: "100%",
        },
      }}
    >
      <DataTableV2
        rowData={rows.rowData}
        loading={rows.loading}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={PAGE_SIZE}
        paginationPageSizeSelector={[PAGE_SIZE]}
        {...dataTableOptions}
        autoSizeStrategy={undefined}
      />
    </Box>
  );
};
